module.exports = __webpack_public_path__ + "static/media/davex.2f3f1961.png";